import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { User } from '../models/User';
//import 'rxjs/add/operator/map';
//import { Observable } from 'rxjs/Observable';
import { PlatformLocation } from '@angular/common';


@Injectable({
  providedIn: 'root'
})

export class UserService {
  constructor(
    private http: HttpClient, private location: PlatformLocation) { }


  deleteUser(user: User)  {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token') || "").access_token);
    headers = headers.append("Content-Type", "application/json");

    return this.http.delete<boolean>(this.location.getBaseHrefFromDOM() + 'api/users/' + user.Id, { headers: headers });
  }
  getUsers(startingWith: string) {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token') || "").access_token);
    headers = headers.append("Content-Type", "application/json");

    return this.http.get<User[]>(this.location.getBaseHrefFromDOM() + (`api/allusers/${startingWith}`), { headers: headers });
  }

  addUser(user: User) {

    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token') || "").access_token);
    headers = headers.append("Content-Type", "application/json");

    return this.http.post(this.location.getBaseHrefFromDOM() + 'api/users', JSON.stringify(user), { headers: headers })
  }

  updateUser(user: User) {

    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token') || "").access_token);
    headers = headers.append("Content-Type", "application/json");

    return this.http.put(this.location.getBaseHrefFromDOM() + 'api/users', JSON.stringify(user), { headers: headers })
  }

  acceptTerms(userId: string) {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token') || "").access_token);
    headers = headers.append("Content-Type", "application/json");

    return this.http.post(this.location.getBaseHrefFromDOM() + 'api/users/accept', userId, { headers: headers })
  }

  getCurrentUser() {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token') || "").access_token);
    headers = headers.append("Content-Type", "application/json");

    return this.http.get<User>(this.location.getBaseHrefFromDOM() + 'api/users/current', { headers: headers });
  }

  getUserById(id: string) {

    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token') || "").access_token);
    headers = headers.append("Content-Type", "application/json");

    return this.http.get<User>(this.location.getBaseHrefFromDOM() + 'api/users/' + id, { headers: headers });
  }

  changePassword(resetData : any)  {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token') || "").access_token);
    headers = headers.append("Content-Type", "application/json");
    return this.http.post<boolean>(this.location.getBaseHrefFromDOM() + 'api/users/changepassword', JSON.stringify(resetData), { headers: headers });
  }

  resetPassword(email : string) {
    let headers = new HttpHeaders();
    headers = headers.append("Content-Type", "application/json");
    return this.http.get<boolean>(this.location.getBaseHrefFromDOM() + 'api/users/resetpassword/' + encodeURIComponent(email), { headers: headers });
  }

  resetWithToken(userId: string, token: string, password: string) {
    let headers = new HttpHeaders();
    headers = headers.append("Content-Type", "application/json");
    return this.http.post<string>(this.location.getBaseHrefFromDOM() + 'api/users/reset?userid=' + userId + "&token=" + encodeURIComponent(token), JSON.stringify(password), { headers: headers });
  }

  IsEmailInUse(email: string) {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token') || "").access_token);
    headers = headers.append("Content-Type", "application/json");
    return this.http.get<boolean>(this.location.getBaseHrefFromDOM() + 'api/users/isemailinuse/' + email, { headers: headers });
  }
}
